import { createMultiStyleConfigHelpers, defineStyle, } from '@chakra-ui/react';
import { switchAnatomy as parts } from '@chakra-ui/anatomy';
import { ThemeColorToken } from '../theme-tokens';
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);
const baseTrackStyle = defineStyle({
    backgroundColor: ThemeColorToken.Surface,
    borderColor: ThemeColorToken.OnSurfaceSubdued,
    borderStyle: 'solid',
    borderWidth: '2px',
    _checked: {
        backgroundColor: ThemeColorToken.Accent,
        borderColor: ThemeColorToken.Accent,
    },
    _disabled: {
        opacity: 0.48,
    },
});
const baseThumbStyle = defineStyle({
    backgroundColor: ThemeColorToken.OnSurfaceSubdued,
    _checked: {
        backgroundColor: ThemeColorToken.OnAccent,
    },
    _disabled: {
        opacity: 0.48,
    },
});
const sizes = {
    sm: definePartsStyle({
        thumb: {
            width: '12px',
            height: '12px',
            _checked: {
                transform: 'translate(11px, -1px)',
                width: '14px',
                height: '14px',
            },
        },
        track: {
            width: '24px',
            height: '12px',
        },
        container: {
            width: '32px',
            height: '20px',
        },
    }),
    md: definePartsStyle({
        thumb: {
            width: '16px',
            height: '16px',
            _checked: {
                transform: 'translate(15px, -1px)',
                width: '18px',
                height: '18px',
            },
        },
        track: {
            width: '32px',
            height: '16px',
        },
        container: {
            width: '40px',
            height: '24px',
        },
    }),
};
const baseStyle = definePartsStyle({
    track: baseTrackStyle,
    thumb: baseThumbStyle,
});
export const switchConfig = defineMultiStyleConfig({
    baseStyle,
    sizes,
});
//# sourceMappingURL=switch-theme.js.map